import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

const QK = ['team-members'];
const ADMIN_QK = ['team-members-admin'];

export type SwapMode = 'swap' | 'replace_primary' | 'replace_secondary';

type SwapInput = {
  id: string;
  mode: SwapMode;
  new_value?: string;
  demote_old?: boolean;
};

type SwapResponse = {
  id: string;
  ig_username: string;
  personal_ig_username: string;
  manychat_cleared: boolean;
};

export function useSwapIg() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: SwapInput) =>
      pb.send<SwapResponse>(`/api/team-members/swap-ig/${v.id}`, {
        method: 'POST',
        body: {
          mode: v.mode,
          new_value: v.new_value,
          demote_old: v.demote_old,
        },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
      qc.invalidateQueries({ queryKey: ADMIN_QK });
      toast('Instagram actualizado', 'success');
    },
    onError: (err: unknown) => {
      const msg = err instanceof Error ? err.message : 'Error al actualizar';
      toast(msg, 'error');
    },
  });
}

export function useRelinkManychat() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send<{ id: string; manychat_subscriber_id: string }>(
        `/api/team-members/relink-manychat/${id}`,
        { method: 'POST' }
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK });
      qc.invalidateQueries({ queryKey: ADMIN_QK });
      toast('ManyChat re-vinculado', 'success');
    },
    onError: () => toast('Error al re-vincular', 'error'),
  });
}
